export default "__VITE_ASSET__Bmqxp$hC__"